import PropTypes from "prop-types";

/** Sticky "Your estimate" summary beside the enroll form. Pass `websites` as null to hide that row. */
function EstimatePanel({ packageLabel, websites, rate, total, per, fine }) {
	return (
		<aside className="summary" aria-label="Your monthly estimate">
			<h3>Your estimate</h3>
			<div className="sline">
				<span>Package</span>
				<span>{packageLabel}</span>
			</div>
			{websites !== null && (
				<div className="sline">
					<span>Websites</span>
					<span>{websites}</span>
				</div>
			)}
			<div className="sline">
				<span>Rate per website</span>
				<span>{rate}</span>
			</div>
			<div className="total">
				<div className="amt">{total}</div>
				<div className="per">{per}</div>
			</div>
			<p className="fine">{fine}</p>
		</aside>
	);
}

EstimatePanel.propTypes = {
	packageLabel: PropTypes.string.isRequired,
	websites: PropTypes.string,
	rate: PropTypes.string.isRequired,
	total: PropTypes.string.isRequired,
	per: PropTypes.string.isRequired,
	fine: PropTypes.string.isRequired,
};

export default EstimatePanel;
